export const defaulChargeInstanceData = {
    "charge_data": {
        "issue_date": "",
        "due_date": "",
        "amount_collected": "",
        "status_name": ""
    },
    "status_metrics": [
        {
            "label": "",
            "color": "",
            "value": 0
        }
    ]
}